import { useMemo, useCallback, useRef } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/noAuthApiClient';
import { emptySearchResponse, userProfilePath } from '../../consts';
import uniqBy from 'hs-lodash/uniqBy';
const GET_INDUSTRIES = registerQuery({
  fieldName: 'industries',
  args: ['offset', 'count', 'query'],

  fetcher({
    offset,
    count,
    query
  }) {
    return http.get(`${userProfilePath}/industries/search`, {
      query: Object.assign({
        offset,
        count
      }, query && {
        query
      })
    });
  }

});
export const useIndustries = () => {
  const cumulativeIndustries = useRef([]);
  const {
    data,
    error: industriesError,
    loading: industriesLoading,
    fetchMore
  } = useQuery(GET_INDUSTRIES, {
    variables: {
      offset: 0,
      count: 50,
      query: ''
    }
  });
  const industries = useMemo(() => data ? data.industries : emptySearchResponse, [data]);
  const getIndustries = useCallback((query, offset) => {
    return fetchMore({
      variables: {
        query,
        offset,
        count: 50
      }
    }).then(response => {
      if (query) {
        return response.data.industries;
      }

      const cumulativeResults = uniqBy([...cumulativeIndustries.current, ...response.data.industries.results], industry => industry.id);
      cumulativeIndustries.current = cumulativeResults;
      return Object.assign({}, response.data.industries, {
        results: cumulativeResults
      });
    });
  }, [cumulativeIndustries, fetchMore]);
  return {
    industries,
    industriesError,
    industriesLoading,
    getIndustries
  };
};